import * as React from 'react'
import { Link } from 'react-router-dom'

import { twTextStyles } from '../styles'
import Button from './Button'

type Modifiers = Partial<{
  accent: 'blue' | 'green'
  primary: boolean
  secondary: boolean
  hidden: boolean
  tertiary: boolean
}>

export type ActionButtonProps = Modifiers & {
  action?: () => void
  block?: boolean
  children?: JSX.Element
  className?: string
  href?: string
  disabled?: boolean
  hidden?: boolean
  key?: string
  text: string
}

const primarySecondaryStyles = `${twTextStyles.paleGray2Bold13} rounded min-w-[95px] py-[7px] px-5`

const commonStyles = 'disabled:opacity-50 text-center !text-s'

const primaryGreenStyles = 'bg-apple-green text-pale-gray2'

const primaryBlueStyles = 'bg-azure text-pale-gray2'

const secondaryStyles = 'bg-pale-gray text-charcoal-gray2'

const tertiaryStyles = 'text-azure font-opensans text-xs font-normal p-0'

const hiddenStyles = 'invisible'

const getStyles = ({ accent = 'green', primary, secondary, tertiary, hidden }: Modifiers) => {
  if (primary) {
    return `${commonStyles} ${primarySecondaryStyles} ${
      accent === 'green' ? primaryGreenStyles : primaryBlueStyles
    } ${hidden ? hiddenStyles : ''}`
  }
  if (secondary) {
    return `${commonStyles} ${primarySecondaryStyles} ${secondaryStyles} ${
      hidden ? hiddenStyles : ''
    }`
  }
  if (tertiary) {
    return `${commonStyles} ${tertiaryStyles} ${hidden ? hiddenStyles : ''}`
  }
}

const ActionButton = ({
  action,
  block,
  children,
  className,
  disabled,
  href,
  text,
  ...modifiers
}: ActionButtonProps) =>
  href ? (
    <Link className={`${getStyles(modifiers)} ${className ?? ''}`} to={href}>
      {children ?? text}
    </Link>
  ) : (
    <Button
      active={!disabled}
      handleClick={action}
      tw={`${getStyles(modifiers)} ${className ?? ''}`}
    >
      {children ?? text}
    </Button>
  )

export { getStyles }
export default ActionButton
